export default {"src":"/_next/static/media/wifi.b9be743f.svg","height":15,"width":20,"blurWidth":0,"blurHeight":0};